import {Services} from 'core';
import * as TYPES from './constants';
import {API, jobsPageSize, defaultJobSort} from 'config/employer.config';
import {opportunityDetailUrl} from 'config/opportunityApi';
import {
  requestEmployerJobs,
  receiveEmployerJobs,
  handleEmployerJobsError,
  employerJobStatusUpdate,
} from './actions';

const initialState = {
  data: null,
  error: null,
  request: null,
};
const services = new Services();

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_EMPLOYER_JOBS:
      return {
        ...state,
        request: true,
      };
    case TYPES.RECEIVE_EMPLOYER_JOBS:
      return {
        ...state,
        error: false,
        request: false,
        data: action.payload || {},
      };
    case TYPES.EMPLOYER_JOBS_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    case TYPES.CLEAR_EMPLOYER_JOBS:
      return {
        ...initialState,
      };
    case TYPES.EMPLOYER_JOB_STATUS_UPDATE:
      return {
        ...state,
        error: false,
        request: false,
      };
    default:
      return state;
  }
};

export const fetchJobs = ({
  page = 0,
  searchKey = '',
  sort = defaultJobSort,
  pageSize = jobsPageSize,
}) => (dispatch, getState) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  dispatch(requestEmployerJobs());
  try {
    let endpoint = `${
      API.administration.opportunities
    }?opportunity_type=job&page_size=${pageSize}&page=${page +
      1}&sort_by=${sort}`;
    if (searchKey) {
      endpoint += `&search=${searchKey}`;
    }
    return services
      .fetchRecords(endpoint, token)
      .then(res => {
        dispatch(receiveEmployerJobs(res));
      })
      .catch(err => {
        console.log(err);
        dispatch(handleEmployerJobsError(err));
      });
  } catch (error) {
    console.log(error);
    dispatch(handleEmployerJobsError(error));
  }
};

export const deleteJob = (deleteJobId, callback) => (dispatch, getState) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  try {
    const endPoint = opportunityDetailUrl(deleteJobId);
    return services
      .deleteRecord(token, endPoint)
      .then(res => {
        if (res) {
          if (callback) callback(res);
        }
      })
      .catch(err => {
        console.log(err);
        dispatch(handleEmployerJobsError(err));
      });
  } catch (error) {
    console.log(error);
    dispatch(handleEmployerJobsError(error));
  }
};

export const updateJobStatus = (id, status, callback) => (
  dispatch,
  getState
) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  try {
    dispatch(requestEmployerJobs());
    let endPoint = opportunityDetailUrl(id);
    let bodyData = {
      is_published: status,
    };
    return services
      .updateStatus(token, endPoint, bodyData)
      .then(res => {
        if (res) {
          dispatch(employerJobStatusUpdate());
          if (callback) callback(res);
        }
      })
      .catch(err => {
        console.log(err);
        dispatch(handleEmployerJobsError(err));
      });
  } catch (error) {
    console.log(error);
    dispatch(handleEmployerJobsError(error));
  }
};
